import { RootState } from '@/store/types/RootState';

export const selectGetRecentActivityLoadingStatus = (state: RootState) =>
  state.recentActivity.statuses.getRecentActivityList.isLoading;
export const selectRecentActivityListPagination = (state: RootState) => state.recentActivity.data.pagination;
export const selectRecentActivityList = (state: RootState) => state.recentActivity.data.listings;
export const selectRecentActivitySavedFiltersForSending = (state: RootState) =>
  state.recentActivity.savedFiltersForSending;
